// extracted by mini-css-extract-plugin
export default {"single-payment-links":"single-payment-link_single-payment-links__UnA-b"};